module.exports = __webpack_public_path__ + "img/DTMTrophy.4ee364b4.svg";